import { render } from "./Agb.vue?vue&type=template&id=4707e726"
import script from "./Agb.vue?vue&type=script&lang=js"
export * from "./Agb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__